import {metadataText} from '@/components/MetadataLanguageField';
import React, { useState } from "react";
import { X } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

// Public gallery with lightbox. Accepts legacy string[] or object[] {url,caption,cover}.
export default function GalleryView({ gallery = [] }) {
  const { lang } = useLang(); const it = lang === "it";
  const [open, setOpen] = useState(null);
  React.useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") setOpen(null); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);
  const items = gallery.map((g, i) => typeof g === "string" ? { url: g, caption: "", cover: i === 0 } : g)
    .filter(g => g && g.url)
    .sort((a, b) => (b.cover ? 1 : 0) - (a.cover ? 1 : 0));
  if (!items.length) return null;
  return (
    <div data-testid="gallery-view">
      <div className="grid grid-cols-2 gap-3">
        {items.map((g, i) => (
          <button key={i} type="button" onClick={() => setOpen(g)} className="block focus:outline-none focus:ring-2 focus:ring-[#E3B24C] rounded-md">
            <img src={g.url} alt={metadataText(g,"caption",lang) || (it ? "Immagine del soggetto" : "Subject image")} loading="lazy"
              className="rounded-md object-cover h-28 w-full border border-[#E2DACB]" />
          </button>
        ))}
      </div>
      {open && (
        <div className="fixed inset-0 z-[1100] bg-black/80 flex items-center justify-center p-4" onClick={() => setOpen(null)} data-testid="gallery-lightbox">
          <button type="button" aria-label={it ? "Chiudi" : "Close"} className="absolute top-4 right-4 text-white" onClick={() => setOpen(null)}><X size={28} /></button>
          <figure className="max-w-4xl w-full" onClick={e => e.stopPropagation()}>
            <img src={open.url} alt={metadataText(open,"caption",lang) || (it ? "Immagine del soggetto" : "Subject image")} className="w-full max-h-[80vh] object-contain rounded" />
            {metadataText(open,"caption",lang) && <figcaption className="text-center text-[#F8F5EA]/90 text-sm mt-3">{metadataText(open,"caption",lang)}</figcaption>}
          </figure>
        </div>
      )}
    </div>
  );
}

